import React, { Component } from 'react';
// import { connect } from 'react-redux';

import { Form, InputField, ResetOnSuccess, FormError } from '../form';

import ActivateModalTrigger from '../billing/ActivateModalTrigger';
import AccountLimitsError from '../billing/AccountLimitsError';

import { FormGroup, Button } from 'reactstrap';
// import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';

import classNames from 'classnames';

// import { size, map, last, filter, find, indexOf, isEmpty } from 'lodash';

import { InputGroupAddon, InputGroup } from 'reactstrap';


class ProjectDomainsForm extends Component {
  render () {
    const { onSubmit, onSuccess, onFail, resetOnSuccess, initialValues, submitValue, hideName } = this.props
    
    return (
      <Form
        {...{onSubmit, onSuccess, onFail, resetOnSuccess}}
        mutators={{...arrayMutators}}
        initialValues={ {...(initialValues || {})} }
        render={({ submitError, handleSubmit, submitting, pristine, values, form:{reset, mutators: { push, pop }} }) => (
          
          <form onSubmit={handleSubmit} noValidate={true} name="domain">
            {submitError && <FormError>{submitError}</FormError>}
            
            <ActivateModalTrigger />
            <AccountLimitsError />
            
            <FormGroup className={classNames({"hide": hideName})}>
              <InputGroup>
                <InputField meta={{submitting}} name="name" type="text" placeholder="Domain name" />
                
                <InputGroupAddon addonType="append">
                  <Button
                    color="primary"
                    type="submit"
                    className="btn-wide upcase"
                    disabled={submitting}>
                    { submitValue || 'Add' }
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
            
            <ResetOnSuccess enabled={true} reset={reset} />
            
          </form>
        )}
      />
    )
  };
}
// <pre>{JSON.stringify(values, 0, 2)}</pre>

export default ProjectDomainsForm;


// WEBPACK FOOTER //
// ./src/components/Projects/domainsForm.js